import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Game } from '../../../Core'

import * as tutorialActions from '../../tutorial.actions'
import * as tutorialSelectors from '../../tutorial.selectors'

import CreateQuestion from '../../../Mars/Quizzes/CreateQuestion/CreateQuestion'

const mapDispatchToProps = (dispatch) => ({
  createQuestion: bindActionCreators(tutorialActions.createQuestion, dispatch),
})

const mapStateToProps = (state) => ({
  loading: false,
  isCreatePenalized: false,
  isPortable: Game.selectors.isPortable(state),

  //mocked
  prizeCoins: tutorialSelectors.getPrizeCoins(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CreateQuestion))
